/* eslint-disable */
import React from "react"
import InlineMultiSelectDropdown from "../../molecules/InlineMultiSelectDropdown.molecule"

const TeamMemberSortFilter = ({ value, onChange, teamMembers, ...props }) => {
  return (
    <InlineMultiSelectDropdown
      options={teamMembers.map((group) => ({
        ...group,
        items: [...group.items].sort((a, b) => {
          if (a.value < b.value) return -1
          if (a.value > b.value) return 1
          return 0
        }),
      }))}
      value={value}
      hasSearchBar
      hideToggleButton
      optionGroupLabel="active"
      optionGroupChildren="items"
      optionGroupTemplate={(option) => {
        return option.active ? "Activo" : "Inactivo"
      }}
      className="consumo-semanal-team-member-dropdown"
      onChange={onChange}
      itemTemplate={(option) => {
        return option.label
      }}
      optionLabel="label"
      optionValue="value"
      initiallyExpanded
      placeholder="Filtrar integrante"
      emptyFilterMessage="Sin resultados ¿Seguro que trabaja aquí?"
      maxSelectedLabels={1}
      selectedItemsLabel={`${(value || []).length} integrantes seleccionados`}
      {...props}
    />
  )
}

export default TeamMemberSortFilter

/**
 * @typedef {Object} TeamMemberSortFilterProps
 * @property {{ value: Array<number> | null, filterCallback: (value: Array<number>) => void }} filterOptions - Opciones del filtro.
 * @property {Array<{active: number, items: Array<{label: string, value: number}>}>} teamMembers - Lista de integrantes del equipo.
 */
